import { render, staticRenderFns } from "./ObservationsStudyOrder.vue?vue&type=template&id=64644f39&scoped=true"
import script from "./ObservationsStudyOrder.vue?vue&type=script&lang=js"
export * from "./ObservationsStudyOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64644f39",
  null
  
)

export default component.exports